module.exports = __webpack_public_path__ + "img/Cover View - 1.e4741e31.svg";